import { type Feature, type LineString, lineString } from '@turf/helpers';
import type { LineProperties } from '@alltrails/types/CustomRoute';
import { SegmentPolyline } from '../../../types/CustomRoute';
import { getLineColor, getLineOutlineColor } from '../../../utils/customRoutes/colors';
import { reverseCoord } from '../../../utils/legacyGeoJSONConversions';

export const getSegmentIndexFromLineId = (id?: string) => {
  const match = id?.match(/^segment-(\d+)-path-/);
  return match ? Number(match[1]) : undefined;
};

const getLineStrings = (segmentPolyline: SegmentPolyline, opacity?: number, segmentIndex?: number) => {
  const { color, paths } = segmentPolyline;
  const lineColor = getLineColor(color);
  const lineOutlineColor = getLineOutlineColor(color);

  return paths.reduce(
    (acc, path, index) => {
      if (!path || path.points.length <= 1) {
        return acc;
      }
      const { points, freeDraw } = path;
      acc.push(
        lineString<LineProperties>(points.map(reverseCoord), {
          id: `segment-${segmentIndex ?? 0}-path-${index}`,
          pathIndex: index,
          lineColor,
          lineOutlineColor,
          freeDraw,
          ...(opacity !== undefined ? { opacity } : {})
        })
      );
      return acc;
    },
    [] as Feature<LineString, LineProperties>[]
  );
};

export default getLineStrings;
